import { createSlice } from "@reduxjs/toolkit";

interface ProductState {
  filter: any[],
  subcategory: string;
  showHighlight: boolean;
  breadCrumb: Breadcrumb[];
  flyerStartState: any[];
  flyerEndState: any[];
  ComplianceFlag:any[];
  Source:any[];
}


const initialState: ProductState = {
  filter: [],
  subcategory: "All products",
  showHighlight: false,
  breadCrumb: [
    { text: "Home", href: "/" },
    { text: "Products", href: "" },
  ],
  flyerStartState: [],
  flyerEndState:[],
  ComplianceFlag:[],
  Source:[]

};

interface Category {
  count: number;
  isRefined: boolean;
  exhaustive: boolean;
  value: string;
  label: string;
  data: Category[] | null;
}

interface Breadcrumb {
  text: string;
  href: string;
}

export const ProductListingSlice = createSlice({
  name: "productSlice",
  initialState,
  reducers: {

    setFilters: (state, action) => {
      const filterItem = action?.payload
      const filtered = state?.filter?.find(item => item?.filterValue === filterItem?.filterValue);

      if(filtered)
      {
        state.filter = state?.filter?.filter(item => item?.filterValue !== filterItem?.filterValue);
      }
      else
      {
        state?.filter?.push(filterItem);
      }
      
    },

    clearFilters: (state) => {

        state.filter = []
        state.flyerStartState=[]
        state.flyerEndState=[]
      
    },

    setFlyerStart:(state,action)=>{

      state.flyerStartState=action.payload;

    },
    setFlyerEnd:(state,action)=>{

      state.flyerEndState=action.payload;

    },

    setComplianceFlag:(state,action)=>{

      state.ComplianceFlag=action.payload;

    },

    setSource:(state,action)=>{

      state.Source=action.payload;

    },

    setSubcategory: (state, action) => {
      const payload = action.payload.trim();

      if (payload.includes(">")) {
        const parts = payload.split(">").map((item: any) => item.trim());
        const subCategory = parts[parts.length - 1];
        if (state.subcategory !== subCategory) {
          state.subcategory = subCategory;
        } else {
          state.subcategory = parts[parts.length - 2];
          parts.pop();
        }

        state.breadCrumb = [
          { text: "Home", href: "/" },
          ...parts.map((part: any, index: any) => ({
            text: part,
            href: `/${parts.slice(0, index + 1).join("/")}`,
          })),
        ];
        if (state.breadCrumb.length > 0) {
          state.breadCrumb[state.breadCrumb.length - 1].href = "";
        }
        state.showHighlight = false;
      } else {
        state.subcategory = payload;
        state.breadCrumb = [
          { text: "Home", href: "/" },
          { text: payload, href: `` },
        ];
        state.showHighlight = payload !== "All products";
      }
    },
  },
});

export const {
  setSubcategory,setFilters,clearFilters,setFlyerStart,setFlyerEnd,setComplianceFlag,setSource
} = ProductListingSlice.actions;
export const productSliceReducer = ProductListingSlice.reducer;
